module.exports = __webpack_public_path__ + "static/media/KGantin-96-9.104c04a1.jpg";